export const APP_BASE_TITLE = 'Site Testing v2';

export const NAV_LINKS = {
  SITE_TESTING_PUBLIC_WIKI:
    'https://w.amazon.com/bin/view/AmazonCorporateSecurity/TechnicalSecurity/Infrastructure/Services/SiteTestingTool',
  GREENLIGHT_FEEDBACK_SIM:
    'https://issues.amazon.com/issues/create?template=0c149e61-52ff-47d5-a087-5881be965bde',
  SITE_TESTING_BUG_SIM:
    'https://issues.amazon.com/issues/create?template=fbdea463-ceb1-47a8-a416-cd39412302c4',
};

export const ONGUARD_COMMAND_KEYPAD_IDS = [144, 151, 152, 153];

export const TRACKED_EVENT = {
  DOOR_HELD_OPEN: 'Door Held Open',
  DOOR_HELD_OPEN_CANCELED: 'Door Held Open Canceled',
};

export const ERROR_HEADER_NO_ITEMS_TO_EXPORT = 'No items to export';
